"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var react_dom_1 = __importDefault(require("react-dom"));

var withStyles_1 = require("../decorators/withStyles");

var Paper_1 = __importDefault(require("../Tooltip/Paper"));

var adjustPositionUtils_1 = require("./adjustPositionUtils");

var Overlay_styles_1 = require("./Overlay.styles");

var Overlay =
/** @class */
function (_super) {
  __extends(Overlay, _super);

  function Overlay() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isAdjusted: false,
      adjustPlacement: _this.props.placement,
      placement: _this.props.placement
    };
    _this.reAdjust = _this.toggleAdjusted.bind(_this, false);
    return _this;
  }

  Overlay.prototype.componentDidMount = function () {
    this.adjustOverlayPosition();
    window.addEventListener('resize', this.reAdjust);
  };

  Overlay.prototype.UNSAFE_componentWillReceiveProps = function (_a) {
    var placement = _a.placement;

    if (this.props.alwaysAdjust || placement !== this.props.placement) {
      this.toggleAdjusted(false);
      this.togglePlacement(placement);
    }
  };

  Overlay.prototype.componentDidUpdate = function () {
    this.adjustOverlayPosition();
  };

  Overlay.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.reAdjust);
  };

  Overlay.prototype.adjustOverlayPosition = function () {
    if (this.state.isAdjusted) {
      return;
    }

    var _a = this.props,
        underlayElement = _a.underlayElement,
        arrow = _a.arrow,
        theme = _a.theme,
        autoOverflow = _a.autoOverflow,
        container = _a.container,
        reservePlacement = _a.reservePlacement,
        minHeight = _a.minHeight;
    var placement = this.state.placement;
    var overlayOffset = arrow ? theme.paddingArrow : 0;
    var distance = arrow ? theme.paddingArrow : theme.marginTooltip;

    if (!underlayElement) {
      return;
    }

    var overlayStyle = this.overlay.style;
    overlayStyle.left = '0';
    overlayStyle.top = '0';
    var underlayRect = underlayElement.getBoundingClientRect();
    var overlayRect = this.overlay.getBoundingClientRect();
    var maxHeight = adjustPositionUtils_1.adjustMaxHeight(placement, {
      overlayRect: overlayRect,
      underlayRect: underlayRect,
      distance: distance,
      overlayOffset: overlayOffset
    }, minHeight); // Максимальную высоту нужно поставить то расчетов позиции, т.к. в этом случае мы учтем скроллбар

    if (autoOverflow) {
      this.overlayInnerWrapper.style.overflow = 'auto';
      this.overlayInnerWrapper.style.maxHeight = maxHeight + "px";
    }

    overlayRect = this.overlay.getBoundingClientRect();
    var domCalculationOptions = {
      overlayRect: overlayRect,
      underlayRect: underlayRect,
      distance: distance,
      overlayOffset: overlayOffset
    };

    var _b = adjustPositionUtils_1.adjust(placement, domCalculationOptions, autoOverflow, container, reservePlacement),
        top = _b.top,
        left = _b.left,
        arrowTop = _b.arrowTop,
        arrowLeft = _b.arrowLeft,
        adjustPlacement = _b.placement,
        needRecalcRect = _b.needRecalcRect;

    if (needRecalcRect) {
      this.togglePlacement(adjustPlacement);
      return;
    }

    overlayStyle.left = Math.round(left) + "px";
    overlayStyle.top = Math.round(top) + "px";

    if (this.arrow) {
      var arrowStyle = this.arrow.style; // eslint-disable-next-line no-multi-assign

      arrowStyle.marginLeft = arrowStyle.marginRight = arrowStyle.marginTop = '0';

      if (arrowLeft > 0) {
        arrowStyle.marginLeft = Math.round(arrowLeft) + "px";
      } else {
        arrowStyle.marginRight = Math.round(-arrowLeft) + "px";
      }

      arrowStyle.marginTop = Math.round(arrowTop) + "px";
    }

    this.toggleAdjusted(true);
    this.setState({
      adjustPlacement: adjustPlacement
    });
  };

  Overlay.prototype.toggleAdjusted = function (value) {
    this.setState({
      isAdjusted: value
    });
  };

  Overlay.prototype.togglePlacement = function (value) {
    this.setState({
      placement: value
    });
  };

  Overlay.prototype.getChildren = function () {
    var _a;

    var _this = this;

    var props = this.props;
    var children = props.children,
        classes = props.classes,
        arrow = props.arrow,
        placement = props.placement,
        testId = props.testId,
        mode = props.mode,
        customScroll = props.customScroll;
    var innerElement = typeof children === 'function' ? children(function () {
      _this.toggleAdjusted(false);

      _this.adjustOverlayPosition();
    }) : children;
    var realPlacement = this.state.adjustPlacement || placement;
    return react_1.default.createElement("div", {
      className: classes.overlay,
      ref: function ref(element) {
        _this.overlay = element;
      }
    }, react_1.default.createElement(Paper_1.default, {
      testId: testId,
      mode: mode
    }, react_1.default.createElement("div", {
      ref: function ref(element) {
        _this.overlayInnerWrapper = element;
      },
      className: classnames_1.default(customScroll && classes.customScroll)
    }, innerElement)), arrow && react_1.default.createElement("div", {
      "data-test-id": "overlay-arrow",
      ref: function ref(element) {
        _this.arrow = element;
      },
      className: classnames_1.default(classes.overlayArrow, (_a = {}, _a[classes.overlayArrowTop] = !realPlacement || realPlacement === 'top', _a[classes.overlayArrowTopLeft] = realPlacement === 'topLeft', _a[classes.overlayArrowTopRight] = realPlacement === 'topRight', _a[classes.overlayArrowBottom] = realPlacement === 'bottom', _a[classes.overlayArrowBottomLeft] = realPlacement === 'bottomLeft', _a[classes.overlayArrowBottomRight] = realPlacement === 'bottomRight', _a[classes.overlayArrowLeft] = realPlacement === 'left' || realPlacement === 'leftTop', _a[classes.overlayArrowLeftTop] = realPlacement === 'leftTop', _a[classes.overlayArrowRight] = realPlacement === 'right' || realPlacement === 'rightTop', _a[classes.overlayArrowRightTop] = realPlacement === 'rightTop', _a))
    }));
  };

  Overlay.prototype.render = function () {
    var props = this.props;
    var container = props.container;

    if (container) {
      return react_dom_1.default.createPortal(this.getChildren(), container);
    }

    return this.getChildren();
  };

  Overlay = __decorate([withStyles_1.withStyles(Overlay_styles_1.overlayStyles)], Overlay);
  return Overlay;
}(react_1.default.Component);

exports.default = Overlay;